export const V1_BASE_URL = 'v1/sales-channels-apps';
